// Category-specific default images
export const categoryDefaultImages: Record<string, string> = {
  Supplements:
    'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?q=80&w=2000&auto=format&fit=crop',
  'Meal Services':
    'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=2000&auto=format&fit=crop',
  'Kitchen Tools':
    'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2000&auto=format&fit=crop',
  'Nutrition Apps':
    'https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=2000&auto=format&fit=crop',
  'Fitness Equipment':
    'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=2000&auto=format&fit=crop',
  Other:
    'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?q=80&w=2000&auto=format&fit=crop',
}
export const getDefaultImageForCategory = (category: string): string => {
  return categoryDefaultImages[category] || categoryDefaultImages['Other']
}
